import { url } from "./MongoConstants";

const getModel = async (sport = 'nfl') => {
    try {
        const server = url;
        const endpoint = `/api/data/model_recent/${sport.toLowerCase()}`;
        
        const response = await fetch(server + endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            console.log('Failed to get model');
            return [];
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return [];
    }
};

export default getModel;